export default "__VITE_ASSET__37ed45ba__"